'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _dec2, _class, _class2, _temp;

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _reactAddonsCssTransitionGroup = require('react-addons-css-transition-group');

var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);

var _Reviews = require('./Reviews.scss');

var _Reviews2 = _interopRequireDefault(_Reviews);

var _reactIntl = require('react-intl');

var _reactRedux = require('react-redux');

var _Review = require('./Review');

var _Review2 = _interopRequireDefault(_Review);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
  Reviews: {
    displayName: 'Reviews'
  }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
  filename: '/home/runner/work/redux-frontend/redux-frontend/src/components/Review/Reviews.js',
  components: _components,
  locals: [],
  imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
  return function (Component) {
    return _reactTransformCatchErrors2(Component, id);
  };
}

// import RadioReview from './RadioReview';
var img1 = require('theme/images/default-img.png');
var img2 = require('./2.jpg');
var img3 = require('./3.jpg');
var img4 = require('./4.jpg');
var img5 = require('./5.jpg');
var img6 = require('./6.jpg');

var Reviews = _wrapComponent('Reviews')((_dec = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.session.user
  };
}, {}), _dec2 = (0, _reactCssModules2.default)(_Reviews2.default), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Reviews, _Component);

  function Reviews(props) {
    (0, _classCallCheck3.default)(this, Reviews);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Reviews.__proto__ || (0, _getPrototypeOf2.default)(Reviews)).call(this, props));

    _this.loadmore = _this.loadmore.bind(_this);

    if (!(typeof _this.loadmore === 'function')) {
      throw new TypeError('Value of "this.loadmore" violates contract.\n\nExpected:\n() => any\n\nGot:\n' + _inspect(_this.loadmore));
    }

    _this.state = {
      reviewType: 'recent',
      show: 3
    };
    return _this;
  }

  (0, _createClass3.default)(Reviews, [{
    key: 'onChange',
    value: function onChange(type) {
      this.setState({ reviewType: type });
    }
  }, {
    key: 'loadmore',
    value: function loadmore() {
      this.setState({ show: this.state.show + 3 });
    }
  }, {
    key: 'render',
    value: function render() {
      var show = this.state.show;
      var _props = this.props,
          user = _props.user,
          reviews = _props.reviews,
          woReview = _props.woReview,
          lxName = _props.lxName;

      var count = reviews.length + woReview;
      return _react3.default.createElement(
        'div',
        null,
        _react3.default.createElement(
          'div',
          { styleName: 'gray-bg' },
          _react3.default.createElement(
            'div',
            { styleName: 'inner' },
            _react3.default.createElement(
              'div',
              { styleName: count > 0 ? 'reviews-header' : 'no-review-header' },
              _react3.default.createElement(
                'h2',
                null,
                'Booking & Review'
              ),
              count > 0 ? _react3.default.createElement(
                'span',
                null,
                '\xA0',
                '(',
                count,
                ')'
              ) : _react3.default.createElement(
                'span',
                null,
                '\xA0'
              )
            )
          )
        ),
        _react3.default.createElement(
          'div',
          { styleName: 'inner' },
          count > 0 ? _react3.default.createElement(
            'div',
            { styleName: 'reviews-container' },
            _react3.default.createElement(
              _reactAddonsCssTransitionGroup2.default,
              {
                transitionName: 'modal-transition',
                transitionEnterTimeout: 200,
                transitionLeaveTimeout: 200
              },

              // this.props.reviews.filter((obj)=> {
              //   if (reviewType === 'positive') {
              //     if (obj.score >= 4) {
              //       return true;
              //     }
              //     return false;
              //   } else if (reviewType === 'negative') {
              //     if (obj.score <= 2) {
              //       return true;
              //     }
              //     return false;
              //   }
              //   return true;
              // })
              this.props.reviews.map(function (review, index) {
                if (index < show) {
                  return _react3.default.createElement(_Review2.default, { key: review._id, review: review, user: user });
                }
                return null;
              })
            ),
            woReview > 0 && _react3.default.createElement(
              'div',
              null,
              _react3.default.createElement(
                'div',
                { styleName: 'center' },
                _react3.default.createElement(
                  'div',
                  { styleName: 'circle-1' },
                  _react3.default.createElement('img', { src: img1, alt: '1st traveler' })
                ),
                _react3.default.createElement(
                  'div',
                  { styleName: 'circle-2' },
                  _react3.default.createElement('img', { src: img2, alt: '2nd traveler' })
                ),
                _react3.default.createElement(
                  'div',
                  { styleName: 'circle-3' },
                  _react3.default.createElement('img', { src: img3, alt: '3rd traveler' })
                ),
                _react3.default.createElement(
                  'div',
                  { styleName: 'circle-4' },
                  _react3.default.createElement('img', { src: img4, alt: '4th traveler' })
                ),
                _react3.default.createElement(
                  'div',
                  { styleName: 'circle-5' },
                  _react3.default.createElement('img', { src: img5, alt: '5th traveler' })
                ),
                _react3.default.createElement(
                  'div',
                  { styleName: 'circle-6' },
                  _react3.default.createElement('img', { src: img6, alt: '6th traveler' })
                )
              ),
              _react3.default.createElement(
                'h3',
                { styleName: 'wo' },
                '+ ',
                woReview,
                ' more travelers have enjoyed the local experience with ',
                lxName
              )
            ),
            show < this.props.reviews.length && _react3.default.createElement(
              'a',
              { styleName: 'load-more', onClick: this.loadmore },
              'Load more'
            )
          ) : _react3.default.createElement(
            'div',
            { styleName: 'no-review' },
            _react3.default.createElement('div', { styleName: 'no-review-icon' }),
            _react3.default.createElement(
              'p',
              null,
              _react3.default.createElement(
                'span',
                null,
                _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.reviews.no_review', values: { lineBreak: _react3.default.createElement('br', null), name: lxName } })
              )
            )
          )
        )
      );
    }
  }]);
  return Reviews;
}(_react2.Component), _class2.propTypes = {
  woReview: _react2.PropTypes.number,
  lxName: _react2.PropTypes.string,
  user: _react2.PropTypes.object,
  reviews: _react2.PropTypes.array
}, _class2.defaultProps = {
  woReview: 0,
  reviews: []
}, _temp)) || _class) || _class));

exports.default = Reviews;

function _inspect(input, depth) {
  var maxDepth = 4;
  var maxKeys = 15;

  if (depth === undefined) {
    depth = 0;
  }

  depth += 1;

  if (input === null) {
    return 'null';
  } else if (input === undefined) {
    return 'void';
  } else if (typeof input === 'string' || typeof input === 'number' || typeof input === 'boolean') {
    return typeof input === 'undefined' ? 'undefined' : (0, _typeof3.default)(input);
  } else if (Array.isArray(input)) {
    if (input.length > 0) {
      if (depth > maxDepth) return '[...]';

      var first = _inspect(input[0], depth);

      if (input.every(function (item) {
        return _inspect(item, depth) === first;
      })) {
        return first.trim() + '[]';
      } else {
        return '[' + input.slice(0, maxKeys).map(function (item) {
          return _inspect(item, depth);
        }).join(', ') + (input.length >= maxKeys ? ', ...' : '') + ']';
      }
    } else {
      return 'Array';
    }
  } else {
    var keys = (0, _keys2.default)(input);

    if (!keys.length) {
      if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
        return input.constructor.name;
      } else {
        return 'Object';
      }
    }

    if (depth > maxDepth) return '{...}';
    var indent = '  '.repeat(depth - 1);
    var entries = keys.slice(0, maxKeys).map(function (key) {
      return (/^([A-Z_$][A-Z0-9_$]*)$/i.test(key) ? key : (0, _stringify2.default)(key)) + ': ' + _inspect(input[key], depth) + ';';
    }).join('\n  ' + indent);

    if (keys.length >= maxKeys) {
      entries += '\n  ' + indent + '...';
    }

    if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
      return input.constructor.name + ' {\n  ' + indent + entries + '\n' + indent + '}';
    } else {
      return '{\n  ' + indent + entries + '\n' + indent + '}';
    }
  }
}

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Review/Reviews.js
// module id = 473
// module chunks = 0 2